"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrippingForm = useDrippingForm;
const react_1 = require("react");
const translationContext_1 = require("configs/translationContext");
const stores_1 = require("modules/content/dripping/stores");
const drippingFormConvert_1 = __importDefault(require("modules/content/dripping/utils/drippingFormConvert"));
function useDrippingForm({ isBulkOperation, dripping, onClose, onSave }) {
    const { t } = (0, translationContext_1.useTranslation)();
    (0, react_1.useEffect)(() => {
        return () => stores_1.DrippingFormStore.clearAll();
    }, []);
    (0, react_1.useEffect)(() => {
        if (dripping) {
            stores_1.DrippingFormStore.setAllFields(dripping);
        }
        else {
            stores_1.DrippingFormStore.clearAll();
        }
    }, [dripping]);
    const getSaveButtonTitle = () => {
        if (isBulkOperation) {
            return t('dripping_2.new.bulk_action.review.title');
        }
        if (dripping) {
            return t('dripping_2.edit.save_changes');
        }
        return t('dripping_2.actions.schedule');
    };
    const handleClose = (0, react_1.useCallback)(() => {
        const newDrippingAborted = drippingFormConvert_1.default.getDrippingFromStore();
        onClose(newDrippingAborted);
    }, [onClose]);
    const handleSave = (0, react_1.useCallback)(() => {
        const newDripping = drippingFormConvert_1.default.getDrippingFromStore();
        onSave(newDripping);
    }, [onSave]);
    return {
        handleClose,
        handleSave,
        saveButtonTitle: getSaveButtonTitle()
    };
}
